// extracted by mini-css-extract-plugin
export default {"cbody":"sign_cbody__xG3NH","box":"sign_box__jrCLt","cimg":"sign_cimg__ViugO"};